import { TOOLBAR_CLASS_NAME } from '../../constants/toolbar';
import FingoMuiToolbar from '../../fingo/components/MuiToolbar';
import NAVBAR_HEIGHT from '../constants/navbar';

const toolbar = ({ theme }) => ({
  minHeight: NAVBAR_HEIGHT,
  paddingLeft: 32,
  paddingRight: 32,
  paddingTop: 14,
  paddingBottom: 14,
  backgroundColor: theme.palette.primary.main,
});

const MuiToolbar = {
  ...FingoMuiToolbar,
  navbarHeight: NAVBAR_HEIGHT,
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiToolbar.styleOverrides.root({ theme }),
      [`&.${TOOLBAR_CLASS_NAME}`]: toolbar({ theme }),
    }),
  },
};

export default MuiToolbar;
